import * as CAR_END_POINTS from "../constants/endpoints/car";
import axios from "../axios/axios";

export const getCarBrands = () => {
  return axios({
    url: CAR_END_POINTS.GET_CAR_BRANDS,
    method: "GET",
  });
};

export const getCarModels = (brandList) => {
  return axios({
    url: CAR_END_POINTS.GET_CAR_MODELS,
    method: "GET",
    params: {
      carBrandIdList: brandList,
    },
  });
};

export const getCarTransmissionsAndCCs = (modelList) => {
  return axios({
    url: CAR_END_POINTS.GET_CAR_TRANSMISSIONS_AND_CCS,
    method: "GET",
    params: {
      carModelIdList: modelList,
    },
  });
};

export const getCarYears = (carModelIdList) => {
  return axios({
    url: CAR_END_POINTS.GET_CAR_YEARS,
    method: "GET",
    params: {
      carModelIdList,
    },
  });
};
